// Файл user_storage_cleanup.js

/**
 * Модуль обслуживает сценарий `user_storage_cleanup` в разделе `utils`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { storage } from './storage';
import { session_storage } from './session_storage';



const preserved_local_keys = new Set([
    'cookie_consent_v1',
    'pd_consent_v1',
    'potale_crypto_pro_thumbprint',
    'potale_gis_access_token',
]);


export const clear_user_storage = () => {
    storage.all_keys().forEach((key) => {
        if (!preserved_local_keys.has(String(key))) {
            storage.removeState(key);
        }
    });
    session_storage.clear();
};
